import React from 'react';
import PropTypes from 'prop-types';
import DFVPlayer, { canPaintToCanvas } from './DFVPlayer';
import DFVPlayerCanvas from './DFVPlayerCanvas';

// If it is safe to paint to canvas, go with the canvas + video player.
// Otherwise fallback to the video only player.
const DFVPlayerAutoChoice = canPaintToCanvas() ? DFVPlayerCanvas : DFVPlayer;

const DFVPlayerAuto = ({ stream, setStreamError, setIsLoading, setAutoPlayError, autoPlayError, playEndTime, syncMode }) => {
    return (
        <DFVPlayerAutoChoice
            stream={stream}
            setStreamError={setStreamError}
            setIsLoading={setIsLoading}
            setAutoPlayError={setAutoPlayError}
            autoPlayError={autoPlayError}
            playEndTime={playEndTime}
            syncMode={syncMode}
        />
    );
};

DFVPlayerAuto.displayName = 'DFVPlayerAuto';

DFVPlayerAuto.choice = DFVPlayerAutoChoice.displayName;

DFVPlayerAuto.propTypes = {
    stream: PropTypes.string,
    setStreamError: PropTypes.func,
    setIsLoading: PropTypes.func,
    setAutoPlayError: PropTypes.func,
    autoPlayError: PropTypes.bool,
    playEndTime: PropTypes.string,
    syncMode: PropTypes.string
};

export default DFVPlayerAuto;
